export enum ABUSE_TYPE {
  INTENTION = 'intention',
  PUBLICATION = 'publication',
  COMMENT = 'comment',
  USER = 'user',
  MESSAGE = 'message',
  UPLIFT = 'uplift',
}
